// extracted by mini-css-extract-plugin
module.exports = {"content":"company-module--content--3QMKs","managers__row":"company-module--managers__row--2-yPN"};